((angular) => {
  'use strict';

  angular
    .module('App')
    .controller('NavCtrl', [
      '$rootScope',
      '$scope',
      '$mdSidenav',
      '$mdMedia',
      'AuthService',
      'LoginService',
      'ParticipantService',
      NavCtrl,
    ]);

  function NavCtrl(
    $rootScope,
    $scope,
    $mdSidenav,
    $mdMedia,
    authService,
    loginService,
    participantService
  ) {
    const updateLoginStatus = () => {
      this.isAuthenticated = authService.isLoggedIn();
      this.user = authService.getTokenData();

      participantService.current().then((participant) => {
        // console.log(participant);
        this.hasVoucher = participant.has_voucher;
        this.eventCredencial = participant.event.assets.some(
          (a) => a.type === participant.company.type
        );
        this.findRetailer = participant.event.show_marketing_activity;
        this.online = participant.event.online;
        this.restrictList = false;
        this.marketingActivityName = participant.event.marketing_activity_name;
        for (let x of participant.event.activity) {
          for (let y of x.restricted_list) {
            if (y.cpf === participant.cpf) {
              this.restrictList = true;
              break;
            }
          }
        }
      });
    };

    const confirmPresence = () => {
      participantService
        .hasVoucher()
        .then((hasVoucher) => (this.hasVoucher = hasVoucher));
    };

    $scope.$on('login', updateLoginStatus);
    $scope.$on('logout', updateLoginStatus);
    $rootScope.$on('$routeChangeStart', updateLoginStatus);

    $rootScope.$on('confirmPresence', confirmPresence);

    updateLoginStatus();

    this.toggleSidenav = (menuId) => $mdSidenav(menuId).toggle();
    this.hideSidebar = () => $mdMedia('min-width: 991px');
    this.logout = () => {
      loginService.logout();
    };
  }
})(angular);
